module.exports = __webpack_public_path__ + "img/pattern.6844e5f.svg";